import React from 'react'
import styles from './index.module.scss'

interface IProps {}

export default function FormItem(props) {
  return (
    <div className={styles.formItem}>
      <div className={styles.field}>
        <div className={styles.label}>{props.label}</div>
        <div className={styles.cube}>{props.children}</div>
      </div>
      <div className={styles.error}>
        {props.errMsg && <p>{props.errMsg}</p>}
      </div>
    </div>
  )
}
